import { loadStripe } from '@stripe/stripe-js';

const getStripePromise = () =>
  loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY, {
    locale: 'auto',
  });

export default getStripePromise;
